<template>
  <head>
    <title>{{ systemName }}</title>
  </head>

  <router-view ></router-view>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      systemName: process.env.VUE_APP_SYSTEM_NAME || ''
    };
  }
}
</script>

